import { api } from '@api'
import type { Database } from '@hvf/contracts'

export type GoWatchVideoRow = Database['public']['Functions']['get_go_watch_videos']['Returns'][number]

export const getGoWatchVideos = async (): Promise<GoWatchVideoRow[]> => {
	const { data, error } = await api().rpc('get_go_watch_videos')

	if (error) throw new Error(error.message)
	return data ?? []
}

export const deleteGoWatchVideo = async (id: string) => {
	const { error } = await api().from('go_watch_videos').delete().eq('id', id)

	if (error) throw new Error(error.message)
	return true
}
